import '../../../../node_modules/jquery-match-height/jquery.matchHeight.js';

window.addEventListener('load', function(e) {
    $('.jsMatchHeight').matchHeight();
});
  